module.exports = __webpack_public_path__ + "img/joinus-13.9ca35e1c.png";